import { VideoRef } from '../../../type';
import { FeedPageEnum } from '@/store/modules/feed';
import MutedIcon from '../../../imgs/muted.png';

export type ActionBarProps = {
    photoId?: string;
    videoRef?: VideoRef;
    currentIndex?: number;
    feedPage?: FeedPageEnum;
};

export enum ActionType {
    Like = 1,
    UnLike = 2,
    Comment = 3,
    Share = 4,
    Follow = 5,
    Download = 6,
    ExtraActionList = 99,
}

export const ActionLogNameMap: Record<ActionType, string | undefined> = {
    [ActionType.Like]: 'PWA_LIKE_PHOTO',
    [ActionType.UnLike]: undefined, // 这个不用报，只需要点赞的
    [ActionType.Comment]: 'PWA_COMMENT_BUTTON',
    [ActionType.Share]: 'PWA_SHARE_PHOTO',
    [ActionType.Follow]: 'PWA_USER_FOLLOW',
    [ActionType.Download]: undefined,
    [ActionType.ExtraActionList]: undefined, // 这个不用报
};

export interface ActionItem {
    type?: ActionType;
    icon?: string;
    count?: string | number;
    hidden?: boolean;
    onClick?: () => Promise<void> | void;
    _tag?: string;
}

export const IconMap: Record<ActionType, string> = {
    [ActionType.Like]: 'https://cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/assets/pwa_like.png',
    [ActionType.UnLike]: 'https://aws-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/liked.png',
    [ActionType.Comment]: 'https://cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/assets/pwa_comment.png',
    [ActionType.Share]: 'https://cdn-static.kwai.net/kos/s101/nlav11312/kwai-share/assets/pwa_share.png',
    [ActionType.Follow]: 'https://aws-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/follow-icon.svg',
    [ActionType.Download]: 'https://cdn-static.kwai.net/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/download.png',
    [ActionType.ExtraActionList]: 'https://cdn-static.kwai.net/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/extra-action-icon.png',
};
